/**
 * Controla una aplicación de gestión de correo
 */
class formFunctions {

  /**
   * @param {errorClass}
   * @param {successClass}
   */
  constructor(errorClass, successClass) {
    this._errorClass = errorClass;
    this._successClass = successClass;
  }

  /**
   * Valida el input
   */
  cleanForm(form) {
    $(':input', form).each(function() {
        var type = this.type;
        var tag = this.tagName.toLowerCase();
        //limpiamos los valores de los campos…
        if (type == 'text' || type == 'password' || tag == 'textarea' || type == 'email')
        this.value = "";
        // excepto de los checkboxes y radios, le quitamos el checked
        // pero su valor no debe ser cambiado
        else if (type == 'checkbox' || type == 'radio')
        this.checked = false;
        // los selects le ponesmos el indice a -
        else if (tag == 'select')
        this.selectedIndex = 0;
    });

    $('input').each(function(){
      $(this).removeClass(this._successClass);
      $(this).removeClass(this._errorClass);
    });

    $('select').each(function(){
      $(this).removeClass(this._successClass);
      $(this).removeClass(this._errorClass);
    });

    $('textarea').each(function(){
      $(this).removeClass(this._successClass);
      $(this).removeClass(this._errorClass);
    });
  }

}

export default formFunctions;
